<template>
  <bar
    ref="chart"
    :chart-data="data"
    :chart-options="options"
    :plugins="plugins"
    :width="width"
    :height="height"
  />
</template>

<script>
import Chart from 'chart.js/auto';
import {Bar} from "vue-chartjs/legacy";

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 0
    }
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            const chart = this.$refs.chart?.$data?._chart
            chart.update('resize')
          })
        }
      }
    }
  },
  beforeDestroy() {
    const chart = this.$refs.chart?.$data?._chart
    if (chart) chart.destroy()
  }
}
</script>